"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Server response from a CREATE_UPDATE_STREAM or CREATE_UPDATE_STREAM_AND_SET request.
 */
var CreateUpdateStreamResponse = /** @class */ (function () {
    /**
     * Create a new UpdateStreamAddTopicResponse instance
     *
     * @param streamId  the update-stream ID
     * @param retainsValue  indicates if the topic retains a value
     * @param supportsConflation  indicates if the topic supports conflation
     */
    function CreateUpdateStreamResponse(streamId, retainsValue, supportsConflation) {
        this.streamId = streamId;
        this.retainsValue = retainsValue;
        this.supportsConflation = supportsConflation;
    }
    return CreateUpdateStreamResponse;
}());
exports.CreateUpdateStreamResponse = CreateUpdateStreamResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/create-update-stream-response.js
// module id = 1488
// module chunks = 0